import { render, staticRenderFns } from "./PatTopDetails.vue?vue&type=template&id=e4909c64&scoped=true"
import script from "./PatTopDetails.vue?vue&type=script&lang=js"
export * from "./PatTopDetails.vue?vue&type=script&lang=js"
import style0 from "./PatTopDetails.vue?vue&type=style&index=0&id=e4909c64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4909c64",
  null
  
)

export default component.exports